var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoResultsIllustration = function SvgNoResultsIllustration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 47,
    fill: "none",
    viewBox: "0 0 53 47"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#437091",
    d: "M39.48 29.333h-2.107l-.746-.72a17.26 17.26 0 0 0 4.186-11.28C40.813 7.76 33.053 0 23.48 0 14.36 0 6.893 7.04 6.227 16h5.386c.667-6 5.68-10.667 11.867-10.667 6.64 0 12 5.36 12 12s-5.36 12-12 12c-.453 0-.88-.08-1.333-.133v5.387c.453.053.88.08 1.333.08 4.293 0 8.24-1.574 11.28-4.187l.72.747v2.106L48.813 46.64l3.974-3.973z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#437091",
    d: "M15.4 20.853 8.813 27.44l-6.586-6.587-1.894 1.894 6.587 6.586L.333 35.92l1.894 1.893 6.586-6.586 6.587 6.586 1.893-1.893-6.586-6.587 6.586-6.586z"
  })));
};
export default SvgNoResultsIllustration;